import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import "./actions.scss";

interface ISkipModalProps {
  show: boolean;
  onHide: () => void;
  onSkip: (note: string) => void;
}

const SkipModal = ({ show, onHide, onSkip }: ISkipModalProps) => {
  const [note, setNote] = useState("");
  const [error, setError] = useState(false);

  const handleNoteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNote(e.target.value);
    setError(false);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (note.trim() === "") {
      setError(true);
      return;
    }
    onSkip(note);
    onHide();
  };

  useEffect(() => {
    if (show) {
      setNote("");
    }
  }, [show]);

  return (
    <div className="skipModal"> 
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Skip Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="skipNote">
              <Form.Label>Note</Form.Label>
              <Form.Control
                type="text"
                value={note}
                onChange={handleNoteChange}
                required
                isInvalid={error}
              />
              {error && (
                <Form.Control.Feedback type="invalid">
                Please provide a note.
                </Form.Control.Feedback>
              )}
            </Form.Group>
            <div className="skipModal-buttonWrapper"> 
              <Button variant="primary" className="skipModal-button" type="submit">
              Skip
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SkipModal;
